// Main site configuration - Update these values to customize your website
export const SITE_CONFIG = {
  name: 'M2B Solutions',
  tagline: 'Webdesign & individuelle Softwareentwicklung für Unternehmen',
  description:
    'Webdesign & individuelle Softwareentwicklung in Deutschland: moderne Webseiten, maßgeschneiderte Software und DSGVO-konforme Lösungen. Faire Preise & schneller Service.',
  url: 'https://m2b.solutions',
  phone: '+49 176 56127211',
  email: 'info@m2b.solutions',
  bookingUrl: 'https://booking.m2b.solutions',
}

// Company information - Update with your business details
export const COMPANY_INFO = {
  legalName: 'M2B Solutions',
  ownerName: 'Mauricio Muler Bodemann',
  address: {
    street: 'Friedberger Straße 21',
    city: 'Bad Homburg',
    postalCode: '61350',
    country: 'Deutschland',
    countryCode: 'DE',
  },
  vatId: 'DE358596878', // USt-IdNr. (§ 27a UStG)
  serviceAreas: ['Deutschland', 'Europa'],
  languages: ['Deutsch', 'Englisch', 'Suomi'],
  businessHours: {
    monday: '09:00 - 18:00',
    tuesday: '09:00 - 18:00',
    wednesday: '09:00 - 18:00',
    thursday: '09:00 - 18:00',
    friday: '09:00 - 18:00',
    saturday: 'Nach Vereinbarung',
    sunday: 'Nach Vereinbarung',
  },
  socialMedia: {
    googleBusinessProfile: 'https://share.google/57nFsu1TqMahY9HWd',
    linkedin: '',
    facebook: 'https://www.facebook.com/profile.php?id=61586664263179',
    instagram: 'https://www.instagram.com/m2b.solutions/',
    twitter: 'https://x.com/M2B_Solutions',
  },
}

